<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Bella and her husband and her family resides in NL, in a small-town call St. Albans. She comes from a family of 13 children, there are seven brothers and six sisters. She loves the outdoors and loves to spend time in her little cottage by a beautiful river that is famous of salmon fishing. She is a nature lover. In her dreams Bella always felt she was from the past, always on a horse with a war party defending her village a woman warrior. Her passion for telling stories and writing is contagious.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ac7a06da